module.exports = __webpack_public_path__ + "static/media/pro-detail-img2.19f8f04d.jpg";